/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { ResponsiveModeType } from 'src/core/utils/hocs/withResponsive';

/**
 * A context containing the current screen size.
 */
export const ResponsiveContext = React.createContext<ResponsiveModeType>(null);
